import axios from "@/plugins/axios";
import {ActionTree} from "vuex";
import {RootState} from "../types";
import {ConfigState} from "./types";
import {Societe, Groupe, Profil} from "@/shared/Groupe";
import {User} from "@/shared/User";
import {Site} from "@/shared/Site";

export const actions: ActionTree<ConfigState, RootState> = {
  async getSocietes({state, commit}) {
    const user = JSON.parse(localStorage.user);
    const url = `bo/infra/getSocietes`;
    console.log(url);
    return axios
      .get(url)
      .then((response) => {
        const sites = JSON.parse(localStorage.sites);
        for (const societe of response.data) {
          for (const site of sites) {
            // console.log(site.extra);
            if (
              site.libelle === societe.raisonSociale &&
              site.extras !== undefined
            ) {
              societe.codeImplant = site.extras.code_implant;
              break;
            }
          }
        }
        commit("SET_SOCIETES", response.data);

        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getGroupes({state, commit}) {
    const user = JSON.parse(localStorage.user);
    const url = `bo/infra/getRegroupements`;
    return axios
      .get(url)
      .then((response) => {
        commit("SET_GROUPES", response.data);
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getProfils({state, commit}) {
    const user = JSON.parse(localStorage.user);
    const url = `bo/infra/getProfils`;
    // console.log(url);
    return axios
      .get(url)
      .then((response) => {
        commit("SET_PROFILS", response.data);
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getUtilisateurs({state, commit}) {
    const user = JSON.parse(localStorage.user);
    const url = `bo/infra/getUtilisateurs`;
    return axios
      .get(url)
      .then((response) => {
        commit("SET_USERS", response.data);
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  setSocieteACreer({state, commit}, societeACreer) {
    commit("SET_SOCIETES_A_CREER", societeACreer);
  },
  async addSociete({commit, state}, societeToAdd) {
    const url = `bo/infra/newSociete`;
    const URLConfig = `raisonSociale=${societeToAdd.raisonSociale}&restaurantId=${societeToAdd.restaurantId}`;
    return axios
      .post(url, URLConfig, {
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
      })
      .then((response: any) => {
        societeToAdd.id = response.data;
        state.societes.push(societeToAdd);
        const socToCreate = state.societesACreer.filter(
          (soc: any) => soc.restaurantId !== societeToAdd.restaurantId
        );
        console.log(socToCreate);
        commit("SET_SOCIETES", state.societes);
        commit("SET_SOCIETES_A_CREER", socToCreate);
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async removeSociete({state, commit}, societeToRemove) {
    console.log(societeToRemove);
    const url = "bo/infra/removeSociete?id=" + societeToRemove.id;
    //  var URLConfig = "id=" + societe.id;
    return axios
      .get(url)
      .then((data: any) => {
        const socs = state.societes.filter(
          (soc: Societe) => soc.id !== societeToRemove.id
        );
        const msoc = new Site(societeToRemove.raisonSociale);
        msoc.restaurantId = societeToRemove.restaurantId;
        state.societesACreer.push(msoc);
        commit("SET_SOCIETES", socs);
        commit("SET_SOCIETES_A_CREER", state.societesACreer);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async updateOneSociete({commit, state}, societeToUpdate: Societe) {
    const url = `bo/infra/saveSociete?id=${societeToUpdate.id}&raisonSociale=${societeToUpdate.raisonSociale}&restaurantId=${societeToUpdate.restaurantId}`;
    const URLConfig = ``;
    return axios
      .post(url, URLConfig, {
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
      })
      .then((response) => {
        state.societes.map((soc) =>
          soc.id === societeToUpdate.id ? societeToUpdate : soc
        );
        commit("SET_SOCIETES", state.societes);
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async addGroupe({commit, state}, groupeToAdd: Groupe) {
    const url = `bo/infra/newRegroupement`;
    const ids = groupeToAdd.societesPlus.map((societe: Societe) => societe.id);
    const idsMoins = groupeToAdd.societesMoins.map(
      (societe: Societe) => societe.id
    );
    const URLConfig = `raisonSociale=${
      groupeToAdd.raisonSociale
    }&societesIdPlus=${ids.toString()}&societesIdMoins=${idsMoins.toString()}`;
    return axios
      .post(url, URLConfig, {
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
      })
      .then((response) => {
        state.groupes.push(groupeToAdd);
        commit("SET_GROUPES", state.groupes);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async updateOneGroupe({commit, state}, groupeToAdd: Groupe) {
    const url = `bo/infra/saveRegroupement?id=${groupeToAdd.id}`;
    const ids = groupeToAdd.societesPlus.map((societe) => societe.id);
    const idsMoins = groupeToAdd.societesMoins.map((societe) => societe.id);
    const URLConfig = `id=${groupeToAdd.id}&raisonSociale=${
      groupeToAdd.raisonSociale
    }&societesIdPlus=${ids.toString()}&societesIdMoins=${idsMoins.toString()}`;
    return axios
      .post(url, URLConfig, {
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
      })
      .then((response) => {
        state.groupes.map((groupe) =>
          groupe.id === groupeToAdd.id ? groupeToAdd : groupe
        );
        commit("SET_GROUPES", state.groupes);
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async removeGroupe({state, commit}, groupeToRemove) {
    // console.log(groupeToRemove);
    const url = "bo/infra/removeRegroupement?id=" + groupeToRemove.id;
    //  var URLConfig = "id=" + societe.id;
    return axios
      .get(url)
      .then((data: any) => {
        // console.log(data);
        const grs = state.groupes.filter(
          (soc: Groupe) => soc.id !== groupeToRemove.id
        );
        commit("SET_GROUPES", grs);
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async addProfil({commit, state}, profilToAdd: Profil) {
    const url = `bo/infra/newProfile`;
    const ids = profilToAdd.societesPlus.map((societe: Societe) => societe.id);
    const idsMoins = profilToAdd.societesMoins.map(
      (societe: Societe) => societe.id
    );
    let URLConfig = `titre=${
      profilToAdd.titre
    }&societesIdPlus=${ids.toString()}&societesIdMoins=${idsMoins.toString()}&droits=${profilToAdd.droits.toString()}`;
    URLConfig += "&optionsTicket=Générale&criteres=";
    return axios
      .post(url, URLConfig, {
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
      })
      .then((response) => {
        // console.log(response);
        profilToAdd.id = response.data;
        state.profils.push(profilToAdd);
        commit("SET_PROFILS", state.profils);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async updateOneProfil({commit, state}, profilToAdd: Profil) {
    const url = `bo/infra/saveProfile?id=${profilToAdd.id}`;
    const ids = profilToAdd.societesPlus.map((societe: Societe) => societe.id);
    const idsMoins = profilToAdd.societesMoins.map(
      (societe: Societe) => societe.id
    );
    let URLConfig = `titre=${
      profilToAdd.titre
    }&societesIdPlus=${ids.toString()}&societesIdMoins=${idsMoins.toString()}&droits=${profilToAdd.droits.toString()}`;
    URLConfig += "&optionsTicket=Générale&criteres=";
    return axios
      .post(url, URLConfig, {
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
      })
      .then((response) => {
        // console.log(response);
        state.profils.map((profil) =>
          profil.id === profilToAdd.id ? profilToAdd : profil
        );
        commit("SET_PROFILS", state.profils);
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async removeProfil({state, commit}, profilToRemove) {
    const url = "bo/infra/removeProfil?id=" + profilToRemove.id;
    return axios
      .get(url)
      .then((data: any) => {
        const grs = state.profils.filter(
          (soc: Profil) => soc.id !== profilToRemove.id
        );
        commit("SET_PROFILS", grs);
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getDroits() {
    const URL = "bo/infra/getDroits";
    axios
      .get(URL)
      .then((data: any) => {
        return data.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async addUser({commit, state}, userToAdd: User) {
    let url = `bo/infra/newUtilisateur`;
    const ids = userToAdd.societesPlus.map((societe: Societe) => societe.id);
    const idsMoins = userToAdd.societesMoins.map(
      (societe: Societe) => societe.id
    );
    url += `?login=${userToAdd.login}&password=${
      userToAdd.newPassword
    }&rePasswordKey=${userToAdd.rePasswordKey}&email=${
      userToAdd.email
    }&profileId=${userToAdd.profile.id}&activationKey=${
      userToAdd.activationKey
    }&theme=${userToAdd.theme}&couleur=${
      userToAdd.couleur
    }&societesIdPlus=${ids.toString()}&societesIdMoins=${idsMoins.toString()}&role=${
      userToAdd.role
    }&country=${userToAdd.country}&language=${userToAdd.language}`;
    let cmpl: { cle: string; valeur: string; type: string }[] = [];
    if (userToAdd.codeExploitant) {
      cmpl = [
        {
          cle: "code_exploitant",
          valeur: userToAdd.codeExploitant,
          type: "STRING",
        },
      ];
    }
    return axios
      .post(url, cmpl)
      .then((response) => {
        // console.log(response);
        userToAdd.id = response.data;
        state.utilisateurs.push(userToAdd);
        commit("SET_USERS", state.utilisateurs);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async updateOneUser({commit, state}, userToUpdate: User) {
    let url = `bo/infra/saveUtilisateur?id=${userToUpdate.id}`;
    const ids = userToUpdate.societesPlus.map((societe: Societe) => societe.id);
    const idsMoins = userToUpdate.societesMoins.map(
      (societe: Societe) => societe.id
    );
    url += `&login=${userToUpdate.login}&email=${
      userToUpdate.email
    }&profileId=${userToUpdate.profile.id}&activationKey=${
      userToUpdate.activationKey
    }&theme=${
      userToUpdate.theme
    }&couleur=undefined&societesIdPlus=${ids.toString()}&societesIdMoins=${idsMoins.toString()}&role=${
      userToUpdate.role
    }&country=${userToUpdate.country}&language=${userToUpdate.language}`;

    if (
      userToUpdate.newPassword !== null &&
      userToUpdate.newPassword !== undefined
    ) {
      url += `&updatePassword=true&password=${encodeURIComponent(userToUpdate.newPassword)}&rePasswordKey=${encodeURIComponent(userToUpdate.rePasswordKey || "")}`;
    } else {
      url += `&updatePassword=false&password=undefined&rePasswordKey=undefined`;
    }
    // console.log(url);

    const cmpl /*: { cle: string; valeur: string; type: string; }[]*/ =
      new Array();
    // console.log(userToUpdate);
    if (userToUpdate.codeExploitant) {
      // console.log(userToUpdate.complements);
      const complement = {
        cle: "code_exploitant",
        valeur: userToUpdate.codeExploitant,
        type: "STRING",
      };
      cmpl.push(complement);
    }
    // console.log(cmpl);
    return axios
      .post(url, cmpl)
      .then((response: any) => {
        state.utilisateurs.map((usr: any) =>
          usr.id === userToUpdate.id ? userToUpdate : usr
        );
        commit("SET_USERS", state.utilisateurs);
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  setFecRestaurantId({commit}, fecRestaurantId: number | null) {
    commit("SET_FECRESTAURANT_ID", fecRestaurantId);
  },
  async removeUser({state, commit}, userToRemove) {
    const url = "bo/infra/removeUtilisateur?id=" + userToRemove.id;
    return axios
      .get(url)
      .then((data: any) => {
        const grs = state.utilisateurs.filter(
          (soc: User) => soc.id !== userToRemove.id
        );
        commit("SET_USERS", grs);
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async getMessages() {
    const URL = "messages/all";
    return await axios
      .get(URL)
      .then((data: any) => {
        return data.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async getRules() {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const URL = "bo/getListRules?id=" + userId;
    return await axios
      .get(URL)
      .then((data: any) => {
        return data.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  async updateRule({state}, rule: any) {
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    // console.log(rule);
    const URL = `bo/updateRule?id=${userId}&libelle=${rule.libelle}&active=${rule.active}`;
    return await axios
      .get(URL)
      .then((data: any) => {
        // console.log(data);
        return data.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
};
